import styled from '@emotion/styled'

const StyledCreateChart = styled.form`
  background: #fff;
  border-radius: 14px;
  color: #25324b;
  overflow: hidden;

  .chart-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 24px 28px;
    border-bottom: 1px solid #e9edf3;
    background: #f8faff;
  }
  .chart-icon {
    display: grid;
    place-items: center;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    color: #246ac4;
    background: #e9f1ff;
    border: 1px solid #dce8fb;
    border-radius: 12px;
  }
  h2 {
    margin: 0 0 5px;
    font-size: 21px;
    font-weight: 700;
  }
  .chart-header p {
    margin: 0;
    color: #637089;
    font-size: 13px;
  }
  .close-button {
    display: grid;
    place-items: center;
    margin-left: auto;
    padding: 8px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #64748b;
  }
  .close-button:hover {
    background: #e9edf3;
  }
  .chart-body {
    display: flex;
    flex-direction: column;
    gap: 22px;
    padding: 24px 28px;
    max-height: calc(100vh - 240px);
    max-height: calc(100dvh - 240px);
    overflow-y: auto;
  }
  label,
  legend,
  h3 {
    font-size: 14px;
    font-weight: 600;
  }
  .chart-type {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .chart-type label {
    flex-shrink: 0;
    margin: 0;
  }
  .chart-type select {
    max-width: 270px;
    margin-left: auto;
  }
  .form-select,
  .form-control {
    min-height: 44px;
    border: 1px solid #dce2eb;
    border-radius: 8px;
    background-color: #fff;
    color: #25324b;
    font-size: 14px;
  }
  .form-select:focus,
  .form-control:focus {
    border-color: #3699ff;
    box-shadow: 0 0 0 3px #3699ff20;
  }
  .form-select:disabled,
  .form-control:disabled {
    background-color: #f5f7fa;
    color: #778399;
  }
  .chart-section {
    min-width: 0;
    margin: 0;
    padding: 0;
    border: 0;
  }
  .chart-section legend {
    float: none;
    width: auto;
  }
  .chart-section h3,
  .chart-section legend {
    display: flex;
    align-items: center;
    gap: 9px;
    margin: 0;
    line-height: 24px;
  }
  .step-number {
    display: inline-grid;
    place-items: center;
    width: 24px;
    height: 24px;
    border-radius: 7px;
    background: #edf2fa;
    color: #45628b;
    font-size: 12px;
    flex-shrink: 0;
  }
  .section-description {
    margin: 7px 0 12px;
    color: #64748b;
    font-size: 13px;
    line-height: 1.5;
  }
  .tenant-options {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .tenant-option {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px;
    margin: 0;
    border: 1px solid #dce2eb;
    border-radius: 10px;
    cursor: pointer;
    background: #fff;
    transition: border-color 120ms, background 120ms;
  }
  .tenant-option:hover {
    border-color: #8ab7ef;
  }
  .tenant-option.is-selected {
    border-color: #3688e5;
    background: #f0f7ff;
    box-shadow: inset 0 0 0 1px #3688e5;
  }
  .tenant-option:focus-within {
    outline: 3px solid #3699ff40;
    outline-offset: 2px;
  }
  .tenant-option input {
    width: 16px;
    height: 16px;
    accent-color: #2477d4;
    flex-shrink: 0;
  }
  .tenant-copy {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }
  .tenant-name {
    font-size: 13px;
    overflow-wrap: anywhere;
  }
  .tenant-description {
    color: #64748b;
    font-size: 12px;
    font-weight: 400;
  }
  .current-badge {
    align-self: flex-start;
    margin-left: auto;
    padding: 3px 7px;
    border-radius: 5px;
    color: #1c64b4;
    background: #dcecff;
    font-size: 10px;
  }
  .tenant-details {
    margin-top: 10px;
    color: #637089;
    font-size: 12px;
  }
  .tenant-details summary {
    cursor: pointer;
    width: fit-content;
  }
  .tenant-details code {
    display: block;
    margin-top: 6px;
    color: #53637b;
    overflow-wrap: anywhere;
  }
  .section-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .refresh-button,
  .retry-button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 0;
    border: 0;
    background: transparent;
    color: #236fc5;
    font-size: 12px;
    font-weight: 600;
  }
  button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  button:focus-visible {
    outline: 3px solid #3699ff70;
    outline-offset: 3px;
  }
  .field-status,
  .field-error {
    margin: 8px 0 0;
    font-size: 12px;
    line-height: 1.5;
  }
  .field-status {
    color: #64748b;
  }
  .field-error {
    color: #b42336;
  }
  .selection-summary {
    display: flex;
    gap: 10px;
    padding: 14px 16px;
    background: #f0faf5;
    border: 1px solid #ccebd9;
    border-radius: 9px;
    color: #237b51;
  }
  .selection-summary > svg {
    flex-shrink: 0;
    margin-top: 2px;
  }
  .selection-summary strong {
    font-size: 13px;
  }
  .selection-summary-content {
    flex: 1;
    min-width: 0;
  }
  .selection-details {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px 20px;
    margin: 12px 0 0;
  }
  .selection-details > div {
    min-width: 0;
  }
  .selection-details dt {
    margin: 0 0 4px;
    color: #486b5b;
    font-size: 11px;
    font-weight: 500;
  }
  .selection-details dd {
    margin: 0;
    color: #28553f;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.5;
    overflow-wrap: anywhere;
  }
  .native-chart-fields {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .native-chart-fields label {
    display: block;
    margin-bottom: 8px;
  }
  .query-input {
    font-family: monospace;
    resize: vertical;
  }
  .save-error {
    margin: 0;
    padding: 12px 16px;
    border: 1px solid #f4cbd0;
    border-radius: 8px;
    background: #fff5f6;
    color: #b42336;
  }
  .chart-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 18px 28px;
    border-top: 1px solid #e9edf3;
  }
  .chart-footer p {
    margin: 0;
    color: #64748b;
    font-size: 12px;
  }
  .action-buttons {
    display: flex;
    gap: 10px;
    flex-shrink: 0;
  }
  .action-buttons .btn {
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
  }

  @media (max-width: 575px) {
    .selection-details {
      grid-template-columns: 1fr;
    }
    .chart-header {
      padding: 20px;
      gap: 12px;
    }
    .chart-icon {
      display: none;
    }
    h2 {
      font-size: 19px;
    }
    .chart-body {
      padding: 20px;
      max-height: calc(100vh - 255px);
      max-height: calc(100dvh - 255px);
    }
    .tenant-options {
      grid-template-columns: 1fr;
    }
    .chart-type {
      align-items: flex-start;
      flex-direction: column;
      gap: 8px;
    }
    .chart-type select {
      max-width: none;
    }
    .chart-footer {
      padding: 16px 20px;
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }
    .action-buttons .btn {
      flex: 1;
    }
  }
`

export default StyledCreateChart
